module.exports = __webpack_public_path__ + "static/img/David-Swallow.e269acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Swallow.jpg
// module id = PulM
// module chunks = 0